import { render } from "./Receive_delete_button.vue?vue&type=template&id=1dac6474&scoped=true"
import script from "./Receive_delete_button.vue?vue&type=script&lang=js"
export * from "./Receive_delete_button.vue?vue&type=script&lang=js"

import "./Receive_delete_button.vue?vue&type=style&index=0&id=1dac6474&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dac6474"]])

export default __exports__